import { actions } from './actions/pdp'
import { mutations } from './mutations/pdp'

export const pdp = {
  namespaced: true,
  state: {
    ui: {},
    breadcrumbs: '',

    selectedCatEntryId: undefined,
    selectedTryLens: undefined,
    correlatedProducts: {},
    correlatedProductsAvailability: {},

    carousel: [],
    carouselIsLoading: true,

    eyeMed: {
      modalActive: false,
      applied: false,
      loading: false,
      error: false,
      success: false,
      errorMessage: false,
      fromRoxPanel: false,
    },

    benefits: undefined,

    // TODO: move to separate vuex module
    findInStore: {
      modalActive: false,
      storeListState: false,
    },
    searchStoreList: [],
    findInStoreSelectedStore: undefined,

    // TODO: group up this information
    isRoxPanelRendered: false,
    selectedRoxOpticLens: undefined,
    selectedRoxOpticFrame: undefined,
    areRxcScriptsLoaded: false,
    rxcLenses: {},

    minicartIsVisible: false,

    productIsLoading: false,

    tryLensesPanelIsVisible: false,
    needHelpPanelIsVisible: false,
    cmsDynamicContent: '',
    selectedFaceShapeProduct: {
      catEntryId: '',
      faceShape: [],
      faceShapeLabel: '',
      hingeDistance: '',
      isMostSoldSize: false,
      label: '',
      outOfStock: false,
      selected: false,
      size: '',
      sizeAriaLabel: '',
      soldOut: false,
    },
    selectedFaceShape: '',
    sizeGuidePanelToogleStore: false,
  },
  getters: {
    breadcrumbs: (state) => {
      if (!state.breadcrumbs) {
        return []
      }
      const parsedBreadcrumbs = JSON.parse(state.breadcrumbs)
      const templateData = parsedBreadcrumbs?.templateData?.bredcrumbdata?.map((element) => ({
        value: element?.details?.value,
        label: element?.details?.label,
      }))
      return [...templateData]
    },
    selectedProduct: (state) => {
      return state.selectedCatEntryId ? state.correlatedProducts[state.selectedCatEntryId] : {}
    },
    selectedProductAvailability: (state) => {
      return state.selectedCatEntryId
        ? state.correlatedProductsAvailability[state.selectedCatEntryId]
        : {}
    },

    carousel: (state) => state.carousel,
    carouselIsLoading: (state) => state.carouselIsLoading,
    giftCardTypes: (state) =>
      state.carousel?.map((element) => ({
        type: element.giftCardType,
        catEntryId: element.catEntryId,
        correlatedCatEntryIds: element.correlatedCatEntryIds,
      })),
    giftCardAmounts: (state) =>
      state.carousel?.find((item) => item.correlatedCatEntryIds.includes(state.selectedCatEntryId))
        ?.giftCardAmounts,
    selectedProductInCarousel: (state) =>
      state.carousel?.find((p) => p.correlatedCatEntryIds.includes(state.selectedCatEntryId)),
    ui: (state) => state.ui,
    getAfterPayModalActive: (state) => state.ui?.afterPayModalActive,
    correlatedProducts: (state) => state.correlatedProducts,
    correlatedProductsAvailability: (state) => state.correlatedProductsAvailability,

    // TODO: move this in separate store module
    isEyeMedApplied: (state) => state.eyeMed.applied,
    benefits: (state) => state.benefits,

    selectedCatEntryId: (state) => state.selectedCatEntryId,

    // TODO: maybe in another module, since it's not related specifically to the PDP (?)
    findInStore: (state) => state.findInStore,
    searchStoreList: (state) => state.searchStoreList,
    findInStoreSelectedStore: (state) => state.findInStoreSelectedStore,

    // TODO: group up this information
    isRoxPanelRendered: (state) => state.isRoxPanelRendered,
    areRxcScriptsLoaded: (state) => state.areRxcScriptsLoaded,
    selectedRoxOpticLens: (state) => state.selectedRoxOpticLens,
    selectedRoxOpticFrame: (state) => state.selectedRoxOpticFrame,
    rxcLenses: (state) => state.rxcLenses,

    minicartIsVisible: (state) => state.minicartIsVisible,
    productIsLoading: (state) => state.productIsLoading,
    tryLensesPanelIsVisible: (state) => state.tryLensesPanelIsVisible,
    needHelpPanelIsVisible: (state) => state.needHelpPanelIsVisible,
    cmsDynamicContent: (state) => state.cmsDynamicContent,
    eyeMedState: (state) => state.eyeMed,
    getSelectedFaceShapeProduct: (state) => state.selectedFaceShapeProduct,
    getSelectedFaceShape: (state) => state.selectedFaceShape,
    sizeGuidePanelToogleStore: (state) => state.sizeGuidePanelToogleStore,
  },
  mutations,
  actions,
}
